// 머리말의 "업데이트 소식" 단추 — 안 읽은 소식이 있을 때만 빨간 점이 붙는다.
//
// 이 파일은 **부르는 자리**일 뿐이고 창 자체는 그리지 않는다(창은 `WhatsNewModal`, 레이아웃에 붙어
// 있다). 예전엔 창이 이 버튼 안에 들어 있어서, 버튼을 머리말에서 빼자 알림의 「확인하기」까지
// 같이 죽었다 — 여는 쪽과 그리는 쪽을 갈라 둔 이유다.
//
// 창을 여는 상태는 주소에 싣는다(`?modal=whats-new`) — 프론트 공통 규칙. 뒤로가기로 닫히고,
// 새로고침해도 열려 있고, 링크로 "여기 봐 봐" 하고 보낼 수 있다.

import { useModal } from "../../hooks/useModal";
import { useWhatsNew } from "../../hooks/useWhatsNew";

export default function WhatsNewButton() {
  const { openModal } = useModal("whats-new");
  const { unread, markAllSeen } = useWhatsNew();

  const open = () => {
    openModal();
    // 여는 순간 읽은 것으로 친다 — 목록을 봤는데도 뱃지가 남아 있으면 고장으로 보인다.
    markAllSeen();
  };

  return (
    <button
      type="button"
      onClick={open}
      title="업데이트 소식 — 최근에 무엇이 바뀌었는지"
      aria-label={unread > 0 ? `업데이트 소식 ${unread}건` : "업데이트 소식"}
      className="relative flex h-11 w-11 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 transition hover:bg-gray-50 hover:text-gray-700 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
        <path d="M3 11v3a1 1 0 0 0 1 1h2l4 3V8L6 11H4a1 1 0 0 0-1 1z" />
        <path d="M15 8.5a4 4 0 0 1 0 7" />
        <path d="M18 6a7 7 0 0 1 0 12" />
      </svg>
      {unread > 0 && (
        <span className="absolute right-2.5 top-2.5 flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-orange-400 opacity-75" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-orange-500 ring-2 ring-white dark:ring-gray-900" />
        </span>
      )}
    </button>
  );
}
